import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var spinnerComponentName = 'QuantumSpinner';
export function getSpinnerUtilityClass(slot) {
    return generateUtilityClass(spinnerComponentName, slot);
}
export var spinnerClasses = generateUtilityClasses(spinnerComponentName, ['root', 'spinner', 'logo']);
